







import { Component, Vue, Prop } from 'vue-property-decorator';
import HomeView from '@/components/HomeView.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'Home',
    components: {
        HomeView,
        NotLoggedPanel
    }
})
export default class Home extends Vue {
    @Prop() private user!: User;
}
